import { render, staticRenderFns } from "./model.vue-select.vue?vue&type=template&id=1ca58e84&"
import script from "./model.vue-select.vue?vue&type=script&lang=ts&"
export * from "./model.vue-select.vue?vue&type=script&lang=ts&"
import style0 from "./model.vue-select.vue?vue&type=style&index=0&id=1ca58e84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports